import { useDispatch } from 'react-redux';

import { ErrRespItem } from '~src/shared/errors/interfaces';
import { showNotification } from '~src/store/app/actions';

type msgPrefix = string | ((key: string) => string);

export function useNotification() {
  const dispatch = useDispatch();

  return {
    notificationsFromAPIErrors: (items: ErrRespItem[], persistent: boolean, msgPrefix?: msgPrefix) => {
      const msgFn = (k: string) => {
        if (typeof msgPrefix === 'function') {
          return msgPrefix(k);
        }

        return msgPrefix + (!!msgPrefix ? '.' : '');
      };
      for (let i = 0; i < items.length; i++) {
        dispatch(
          showNotification({
            txtKey: msgFn(items[i].translation_key) + items[i].translation_key,
            txtProps: items[i].arguments,
            id: 'error_' + items[i].translation_key + i,
            type: 'error',
            persistent,
          }),
        );
      }
    },
  };
}
